module.exports = __webpack_public_path__ + "js/stellarium-web-engine.6d0b1f09.wasm";